import React from 'react';
import cn from 'classnames';
import { Theme } from '../../types/Theme';
import { DH } from '../../utils/DataHook';
import { SavedCreditCardItem } from './SavedCreditCardItem';
import * as s from '../CustomPaymentMethodList/styles.scss';
import { IPublicCreditCard } from '@wix/cashier-core/dist/src/services/CreditCard/types';

export interface SavedCreditCardListProps {
  creditCards: IPublicCreditCard[];
  selectedCardId: string;
  activePaymentComponentNode?: JSX.Element;
  theme?: Theme;

  onChange(cardId: string, cardDetails?: any): void;
}

export const SavedCreditCardsList: React.FunctionComponent<SavedCreditCardListProps> =
  (props) => {
    const handleEnterKey = (e, cardId, creditCardDetails) => {
      const isActionKey = e.key === 'Enter' || e.key === ' ';
      if (isActionKey && props.onChange) {
        props.onChange(cardId, creditCardDetails);
      }
    };

    return (
      <div
        className={cn({
          [s.paymentMethodList]: true,
          [s.noMargin]: true,
          [s.modalTheme]: props.theme === Theme.modal,
        })}
        data-hook={DH.SavedCard.List}
        role="menu"
      >
        {props.creditCards.map((card: IPublicCreditCard) => {
          const selected = props.selectedCardId === card.creditCardId;
          const creditCardDetails = {
            billingAddress: card.billingAddress,
            additionalInformation: card.additionalInformation,
            expired: card.expired,
            expiration: card.expiration,
            network: card.network,
          };
          return (
            <div
              className={s.wrapper}
              key={card.creditCardId}
              role="radiogroup"
              data-hook={DH.SavedCard.Item.Wrapper(card.creditCardId)}
              onKeyDown={(e) =>
                handleEnterKey(e, card.creditCardId, creditCardDetails)
              }
              tabIndex={0}
              aria-checked={selected}
              aria-describedby={`wcn-cc-description-${card.creditCardId}`}
            >
              <SavedCreditCardItem
                theme={props.theme}
                network={card.network}
                cardId={card.creditCardId}
                isExpired={creditCardDetails.expired}
                expiration={card.expiration}
                lastFourDigits={card.lastFourDigits}
                isSelected={selected}
                onClick={() =>
                  props.onChange(card.creditCardId, creditCardDetails)
                }
              />
              {card.creditCardId === props.selectedCardId &&
                props.activePaymentComponentNode && (
                  <div className={s.paymentComponent}>
                    {props.activePaymentComponentNode}
                  </div>
                )}
            </div>
          );
        })}
      </div>
    );
  };
SavedCreditCardsList.displayName = 'SavedCreditCardsList';
